export default function isUrlWhitelisted(url: string, whitelistedUrls: string[]) {
    for (var i = 0; i < whitelistedUrls.length; i++) {
        var regex = wildcardToRegExp(whitelistedUrls[i]);
        if (regex.test(url)) {
            return true;
        }
    }

    return false;
}

function wildcardToRegExp(str: string) {
    return new RegExp('^' + str.split(/\*+/).map(regExpEscape).join('.*') + '$');
}

function regExpEscape(str: string) {
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}
